<small>{{ label }}</small>
<p>{{ value }}</p>
